import { orderIsFreeDutiesEligible } from "../../utils/orderIsFreeDutiesEligible";
import { RequestDutiesRefundCTA } from "./ctas";
export var RequestDutiesReimbursementIA = function RequestDutiesReimbursementIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_NOT_SELECTED(strictLocalize);
  }
  return orderIsFreeDutiesEligible(brandOrder) ? DUTIES_FREE_ORDER(strictLocalize) : NON_DUTIES_FREE_ORDER(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize, articles) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return RequestDutiesRefundCTA(strictLocalize, articles);
  }
  if (!orderIsFreeDutiesEligible(brandOrder)) {
    return undefined;
  }
  return RequestDutiesRefundCTA(strictLocalize, articles);
};
var ORDER_NOT_SELECTED = function ORDER_NOT_SELECTED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_REIMBURSEMENT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WE_WILL_APPLY_DISCOUNT_IF_DUTIES_ARE_COVERED(strictLocalize), YOU_WILL_PAY_THE_CARRIER_IF_DUTIES_ARE_NOT_COVERED(strictLocalize), EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST(strictLocalize)];
    }
  };
};
var DUTIES_FREE_ORDER = function DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_REIMBURSEMENT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST(strictLocalize)];
    }
  };
};
var NON_DUTIES_FREE_ORDER = function NON_DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return DUTIES_REIMBURSEMENT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize)];
    }
  };
};
var DUTIES_REIMBURSEMENT = function DUTIES_REIMBURSEMENT(strictLocalize) {
  return strictLocalize({
    id: "YISJZw",
    defaultMessage: [{
      "type": 0,
      "value": "Reembolso dos direitos aduaneiros"
    }]
  });
};
var WE_WILL_APPLY_DISCOUNT_IF_DUTIES_ARE_COVERED = function WE_WILL_APPLY_DISCOUNT_IF_DUTIES_ARE_COVERED(strictLocalize) {
  return strictLocalize({
    id: "j06O25",
    defaultMessage: [{
      "type": 0,
      "value": "Se os direitos aduaneiros estiverem cobertos para a sua encomenda, aplicaremos um desconto à sua fatura durante o check-out que reflete o custo estimado dos direitos aduaneiros de importação da sua encomenda. A transportadora enviará uma fatura de todos os custos de importação (incluindo os direitos aduaneiros de importação e o IVA) que pagará na íntegra. Se o custo real dos direitos aduaneiros de importação e das taxas de desembolso for superior à promoção que recebeu, pode solicitar o reembolso da diferença em crédito Faire quando a encomenda for entregue."
    }]
  });
};
var YOU_WILL_PAY_THE_CARRIER_IF_DUTIES_ARE_NOT_COVERED = function YOU_WILL_PAY_THE_CARRIER_IF_DUTIES_ARE_NOT_COVERED(strictLocalize) {
  return strictLocalize({
    id: "8rOH2d",
    defaultMessage: [{
      "type": 0,
      "value": "Se os direitos aduaneiros não estiverem cobertos para a sua encomenda, pagará o montante integral diretamente à transportadora e não poderá solicitar o reembolso dos mesmos."
    }]
  });
};
var EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST = function EXCLUDE_TAXES_AND_FEES_FROM_REIMBURSEMENT_REQUEST(strictLocalize) {
  return strictLocalize({
    id: "1ckXmV",
    defaultMessage: [{
      "type": 0,
      "value": "Tenha em atenção que o IVA, os impostos especiais de consumo e outras taxas não são cobertos pela Faire. Por este motivo, exclua-os ao apresentar um pedido de reembolso."
    }]
  });
};
var ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "DH6hjb",
    defaultMessage: [{
      "type": 0,
      "value": "Esta encomenda é elegível para a promoção de direitos aduaneiros gratuitos. Se os direitos aduaneiros estiverem cobertos para a sua encomenda, aplicaremos um desconto à sua fatura durante o check-out que reflete o custo estimado dos direitos aduaneiros de importação da sua encomenda. A transportadora enviará uma fatura de todos os custos de importação (incluindo os direitos aduaneiros de importação e o IVA) que pagará na íntegra. Se o custo real dos direitos aduaneiros de importação e das taxas de desembolso for superior à promoção que recebeu, pode solicitar o reembolso da diferença em crédito Faire quando a encomenda for entregue."
    }]
  });
};
var ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "lmtMK2",
    defaultMessage: [{
      "type": 0,
      "value": "Esta encomenda não é elegível para a promoção de direitos aduaneiros gratuitos. Por este motivo, não poderá solicitar o reembolso do custo dos direitos aduaneiros. A transportadora enviará uma fatura de todos os custos de importação (incluindo os direitos aduaneiros de importação e o IVA) que pagará na íntegra."
    }]
  });
};